import { Chip, Section } from '@patchbay/ui'
import { useQuery } from '@tanstack/react-query'
import { satisfactionCaseQuery } from './api'

const LABEL = { good: 'Good', ok: 'OK', bad: 'Bad' } as const

export function SatisfactionCaseCard({ caseId }: { caseId: string }) {
  const query = useQuery(satisfactionCaseQuery(caseId))
  if (query.isPending) return null
  if (query.isError)
    return (
      <div className="mx-5 mt-3">
        <Section title="Satisfaction">
          <p className="text-sm text-warning">Satisfaction is unreachable; no rating state is inferred.</p>
        </Section>
      </div>
    )
  if (query.data.state === 'not_requested') return null
  const survey = query.data
  const deskRatings = survey.desk_ratings ?? []
  return (
    <div className="mx-5 mt-3">
      <Section
        title="Satisfaction"
        actions={
          survey.rating ? (
            <Chip tone={survey.rating === 'good' ? 'success' : survey.rating === 'bad' ? 'danger' : 'warning'}>{LABEL[survey.rating]}</Chip>
          ) : (
            <Chip tone="neutral">{survey.state.replaceAll('_', ' ')}</Chip>
          )
        }
        bodyClassName="space-y-1"
      >
        {survey.comment ? <p className="text-sm">“{survey.comment}”</p> : null}
        {deskRatings.length ? (
          <p className="text-xs text-muted-foreground">
            Desk Customer Happiness: {deskRatings.map((row) => (row.rating ? LABEL[row.rating] : 'raw rating')).join(', ')}
          </p>
        ) : null}
      </Section>
    </div>
  )
}
